import LazyLoad from 'vanilla-lazyload';

export default function (applicationIds, currency, searchQuery, showApplications = false, productType = 'textile') {
  return {
    lang: '',
    currency: 'CAD',
    categoryNames: [
      'application',
      'acousticApplication',
      'basicColor',
      'composition',
      'flammability',
      'flammabilityEu',
      'collection',
      'brands',
      'fabricType',
      'patternType',
      'performance',
      'innovation',
      'acousticTransparency',
      'usableWidth',
      'usableWidthEu',
      'acousticTileType',
      'acousticInstallation'
    ],
    categories: [],
    products: [],
    tileProducts: [],

    loadedProducts: false,
    loadedTileProducts: false,

    // Pagination
    total: 0,
    pageNumber: 0,
    size: 12,
    tileTotal: 0,

    // Categories
    application: [],
    acousticApplication: [],
    basicColor: [],
    composition: [],
    flammability: [],
    flammabilityEu: [],
    collection: [],
    brands: [],
    fabricType: [],
    patternType: [],
    performance: [],
    innovation: [],
    acousticTransparency: [],
    usableWidth: [],
    usableWidthEu: [],
    acousticTileType: [],
    acousticInstallation: [],
    acousticTileTypeRadioValue: '',
    kitsAvailable: '',

    // Sorting
    sortMethod: 'title.keyword:asc',

    // Search
    searchQuery: '',
    findMatchBasicColorByQuery: false,

    // UI
    currentProductType: productType.split('-')[0] || 'textile',

    init() {
      this.lang = document.querySelector('html').getAttribute('lang');
      this.application = applicationIds;
      this.acousticApplication = applicationIds;
      this.currency = currency;
      this.searchQuery = searchQuery;
      this.kitsAvailable = new URLSearchParams(window.location.search).get('kitsAvailable') == 'true' ? true : false;

      this.initCategories();

      console.log('currentProductType', this.currentProductType);

      if (this.currentProductType == 'textile' || showApplications === true) {
        this.fetchCategories(() => {
          this.fetchProducts((data) => {
            this.products = data.results.products;
            this.total = data.total_hits;
            this.loadedProducts = true;
          });
        });
      }

      if (this.currentProductType == 'acoustic' || showApplications === true) {
        this.fetchTileCategories(() => {
          this.fetchTileProducts((data) => {
            this.tileProducts = data.results.products;
            this.tileTotal = data.total_hits;
            this.loadedTileProducts = true;
          });
        });
      }

      this.$watch(['loadedProducts', 'loadedTileProducts'], () => {
        if (this.loadedProducts &&
          this.loadedTileProducts &&
          this.currentProductType === 'textile' &&
          this.total === 0 &&
          this.tileTotal > 0) {
          this.currentProductType = 'acoustic';
        }
      });

      this.$watch('application', () => {
        this.fetchCategories();
      });

      this.$watch(['searchQuery'], () => {
        this.pageNumber = 0;

        this.fetchProducts((data) => {
          this.products = data.results.products;
          this.total = data.total_hits;
        });
        this.fetchTileProducts((data) => {
          this.tileProducts = data.results.products;
          this.tileTotal = data.total_hits;
        });
      });

      this.$watch(['sortMethod'].concat(this.categoryNames), () => {
        this.pageNumber = 0;

        if (this.currentProductType == 'acoustic') {
          this.fetchTileProducts((data) => {
            this.tileProducts = data.results.products;
            this.tileTotal = data.total_hits;
          });
        } else {
          this.fetchProducts((data) => {
            this.products = data.results.products;
            this.total = data.total_hits;
          });
        }
      });

      this.$watch(this.categoryNames, () => {
        this.addCategoriesToUrls();
      });

      this.$watch('kitsAvailable', () => {
        this.addCategoriesToUrls();
        this.fetchTileProducts((data) => {
          this.tileProducts = data.results.products;
          this.tileTotal = data.total_hits;
        });
      });

      this.$watch('products', () => {
        this.updateImage();
      });
      this.$watch('tileProducts', () => {
        this.updateImage();
      });

      let searchTimeout = null;
      let previousLength = 0;

      this.$watch('searchQuery', () => {
        if (searchTimeout) {
          clearTimeout(searchTimeout);
        }

        if (this.searchQuery.length > 0) {
          let newLength = this.searchQuery.length;

          if (newLength > previousLength) {
            previousLength = newLength;

            searchTimeout = setTimeout(() => {
              window.dataLayer.push({
                event: 'search',
                search_term: this.searchQuery
              });
            }, 500);
          }
        } else {
          previousLength = 0;
        }
      });

      this.$watch('currentProductType', () => {
        this.updateImage();
      });

      this.$watch('acousticTileType', (value) => {
        if (!Array.isArray(value)) {
          this.acousticTileType = [value];
          this.acousticTileTypeRadioValue = String(value);
        }
      });

      this.$watch('acousticTileTypeRadioValue', (value) => {
        this.acousticTileType = [value];
      });
    },

    updateImage() {
      const images = document.querySelectorAll('[image-product-search]');

      images.forEach((image) => {
        LazyLoad.resetStatus(image);
      });

      this.$nextTick(() => {
        window.lazyloadInstance.update();
      });
    },

    initCategories() {
      // eslint-disable-next-line no-undef
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });

      if (params.productType) {
        this.currentProductType = params.productType;
      }

      this.getFilteredCategoryNames().forEach((cat) => {
        if (params[cat]) {
          if (cat === 'acousticTileType') {
            this.acousticTileTypeRadioValue = String(params[cat]);
          }
          this[cat] = params[cat].split(',');
        }
      });
    },

    addCategoriesToUrls() {
      let newURL = [];
      this.getFilteredCategoryNames().forEach((cat) => {
        if (!Array.isArray(this[cat])) {
          const arr = [this[cat]];
          this[cat] = arr;
        }

        if (this[cat].length > 0) {
          newURL.push(cat + '=' + this[cat].join(','));
        }
      });
      if (this.kitsAvailable) {
        newURL.push('kitsAvailable=true');
      } else {
        newURL.push('kitsAvailable=');
      }

      history.replaceState(
        {},
        '',
        window.location.href.split(/[?#]/)[0] + (newURL.length > 0 ? '?' + newURL.join('&') : '')
      );
    },

    fetchCategories(callback) {
      fetch(`/aggregates-by-applications.php?lang=${this.lang}&application=${this.application.join(',')}`)
        .then((response) => response.json())
        .then((data) => {
          delete data.acousticTileType;
          delete data.acousticInstallation;
          this.categories = { ...this.categories, ...data };

          // Sort brands by case insensitive
          this.categories['brands'] = this.categories['brands'].sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
          );
          if (typeof callback === 'function') {
            callback();
          }
        });
    },

    fetchTileCategories(callback) {
      fetch(
        `/aggregates-by-applications.php?lang=${this.lang}&acousticApplication=${this.acousticApplication.join(',')}&acousticTile=true`
      )
        .then((response) => response.json())
        .then((data) => {
          const tileTypeOrder = [
            ['3d-profiles', 'profils-3d'],
            ['flat-profiles', 'profils-plats'],
            ['baffles', 'deflecteurs'],
            ['clouds', 'nuages']
          ];
          const tileTypeIndex = (cat) => {
            const name = (cat.slug || '').trim().toLowerCase();
            const index = tileTypeOrder.findIndex((names) => names.includes(name));
            return index === -1 ? tileTypeOrder.length : index;
          };
          this.categories['acousticTileType'] = data.acousticTileType.sort(
            (a, b) => tileTypeIndex(a) - tileTypeIndex(b)
          );
          this.categories['acousticInstallation'] = data.acousticInstallation;
          this.categories['acousticTileType'].forEach((cat) => {
            cat.hideInHeader = true;
          });
          if (typeof callback === 'function') {
            callback();
          }
        });
    },

    fetchProducts(callback) {
      const params = {
        lang: this.lang,
        start: this.pageNumber * this.size,
        pageSize: this.size,
        sort: this.sortMethod,
        query: this.searchQuery
      };
      this.categoryNames.forEach((name) => {
        params[name] = this[name].join(',');
      });

      const searchParams = new URLSearchParams(params);

      fetch(`/all-products.php?${searchParams}`)
        .then((response) => response.json())
        .then((data) => {
          callback(data);
        });
    },

    fetchTileProducts(callback) {
      const params = {
        lang: this.lang,
        start: this.pageNumber * this.size,
        pageSize: this.size,
        sort: this.sortMethod,
        query: this.searchQuery,
        kitsAvailable: this.kitsAvailable ? true : ''
      };
      this.categoryNames.forEach((name) => {
        if (this[name].length > 0 && name !== 'application') {
          params[name] = this[name];
        }
      });

      const searchParams = new URLSearchParams(params);

      fetch(`/all-products.php?${searchParams}&acousticTile=true`)
        .then((response) => response.json())
        .then((data) => {
          callback(data);
        });
    },

    currentCategories() {
      let cats = [];
      this.getFilteredCategoryNames().forEach((name) => {
        cats = cats.concat(this.getCategories(name));
      });
      return cats;
    },

    getCategories(categoryName) {
      const cats = [];
      this[categoryName].forEach((id) => {
        const cat = this.categories[categoryName]
          ? this.categories[categoryName].find((c) => c.id === parseInt(id))
          : null;
        if (cat) {
          cats.push(cat);
        }
      });
      return cats;
    },

    getFilteredCategoryNames() {
      return this.categoryNames.filter((name) => name !== 'application' || showApplications === true);
    },

    clearCategory(id) {
      this.categoryNames.forEach((name) => {
        this.removeCategory(id, name);
      });
    },

    removeCategory(id, categoryName) {
      this[categoryName] = this[categoryName].filter((cat) => {
        return parseInt(cat) !== id;
      });
    },

    formatCurrency(price) {
      const formatter = new Intl.NumberFormat(this.lang, {
        style: 'currency',
        currency: this.currency
      });
      return formatter.format(price);
    },

    pages() {
      return Array.from({
        length: Math.ceil(this.total / this.size)
      });
    },

    nextPage() {
      this.pageNumber++;
      this.fetchProducts((data) => {
        this.products = this.products.concat(data.results.products);
      });
    },

    pageCount() {
      return Math.ceil(this.total / this.size);
    },

    endResults() {
      if (this.currentProductType == 'acoustic') {
        return this.tileTotal;
      }

      let resultsOnPage = (this.pageNumber + 1) * this.size;

      if (resultsOnPage <= this.total) {
        return resultsOnPage;
      }

      return this.total;
    },

    getAcousticTileTypeSlugById(id) {
      const category = this.categories.acousticTileType.find((cat) => cat.id === parseInt(id));
      return category ? category.slug : null;
    }
  };
}
